module.exports = __webpack_public_path__ + "img/barcode2.c96fcd5c.png";